angular.module('leanlaw').filter("invoiceFilter", ['$filter', function ($filter) {
  return function (invoices, filter) {
    return invoices && invoices.filter(i => {
      return paid(filter, i) && trust(filter, i) && evergreen(filter, i) && ledes(filter, i);
    });
    function paid(filter, i) {
      var paidFilter = filter.paid;
      return !paidFilter || paidFilter.id === 'all' || paidFilter.id === 'open' && i.state.open || paidFilter.id === 'overdue' && i.state.overdue || paidFilter.id === 'notoverdue' && i.state.open && !i.state.overdue || paidFilter.id === 'paid' && i.state.closed;
    }
    function trust(filter, i) {
      var trustFilter = filter.trust;
      return !trustFilter || trustFilter.id === 'all' || trustFilter.id === 'trust' && i.trustBalance || trustFilter.id === 'notrust' && !i.trustBalance;
    }
    function evergreen(filter, i) {
      var evergreenFilter = filter.evergreen;
      return !evergreenFilter || evergreenFilter.id === 'all' || evergreenFilter.id === 'evergreen' && (i.client.billing.billClient ? i.client.billing.evergreen : i.matter.billing.evergreen) || evergreenFilter.id === 'replenish' && i.replenish;
    }
    function ledes(filter, i) {
      var ledesFilter = filter.ledes;
      return !ledesFilter || ledesFilter.id === 'all' || ledesFilter.id === 'ledes' && i.client.codes && i.client.codes.ledes || ledesFilter.id === 'noledes' && !(i.client.codes && i.client.codes.ledes);
    }
  };
}]);